import React, { useState, useRef, useEffect, useCallback } from "react";
import { producaov2 as api, local } from "../../../../services/apis";
import { isAuthAdmin } from "../../../../services/auth";
import {
  Button,
  Form,
  Input,
  Divider,
  ButtonGroup,
  Icon,
} from "semantic-ui-react";
import TextEditor from "../../../../components/Admin/NewTextEditor";
import * as yup from "yup";
import { toast } from "react-toastify";
import Dropzone from "../../../../components/Admin/Dropzone";

import {
  Container,
  Content,
  Title,
  Field,
  Label,
  StyledButton,
  StyledForm,
  StyledDropdown,
  ExcludeButtonContainer,
  CreatedInscritoContainer,
  LineContainer,
  StyledLabel,
  StyledLineContent,
} from "./styles";

import swal from "sweetalert";
import { Link, withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import InscritosEventosSelector from "../../../../components/Admin/InscritosEventosSelector";
import { useRouter } from "../../../../hooks/router";

const EnviarEmailsInscricoesEventos = (props) => {
  const [aluno, setAluno] = useState(null);
  const [emails, setEmails] = useState(null);
  const [evento, setEvento] = useState(null);

  const [alunosOptions, setAlunosOptions] = useState([
    { key: 1, text: "QP Summit 2021", value: 1 },
    {
      key: 2,
      text: "Lançamento do Pensamento Crítico",
      value: 3,
    },
  ]);

  const [eventosOptions, setEventoOptions] = useState([
    { key: 1, text: "QP Summit 2021", value: 1 },
    {
      key: 2,
      text: "Lançamento do Pensamento Crítico",
      value: 3,
    },
  ]);

  const [emailsOptions, setEmailsOptions] = useState([
    { key: 1, text: "QP Summit 2021", value: 1 },
    {
      key: 2,
      text: "Lançamento do Pensamento Crítico",
      value: 3,
    },
  ]);

  const router = useRouter();

  const parceirosOptions = {
    0: "Não parceiro (aluno)",
    1: "Embaixador",
    2: "EJ",
  };

  const getEventos = async () => {
    const eventos = (await api.get("eventos")).data;

    const newEventosOptions = eventos.map((evento) => ({
      key: evento.id,
      value: evento.id,
      text: evento.titulo,
    }));

    setEventoOptions(newEventosOptions);
  };

  const getEmails = useCallback(async () => {
    const params = {};

    if (evento) {
      params.id_evento = evento;
    }

    const emailsEventos = (
      await api.get("/admin/inscricoes-eventos/emails", { params })
    ).data;

    const newEmailsOptions = emailsEventos
      .filter((evento) => evento?.email)
      .map((evento) => ({
        key: evento.id,
        value: evento.id,
        text: evento?.email?.titulo,
      }));

    setEmailsOptions(newEmailsOptions);
  }, [evento]);

  const handleDropdownChange = useCallback((value, setState) => {
    setState(value);
  }, []);

  const handleSend = useCallback(async () => {
    try {
      const payload = {
        id_inscricao: aluno,
        emails,
        id_evento: evento,
      };

      const data = (
        await api.post("/admin/inscricoes-eventos/force-email-send", payload)
      ).data;

      swal("Sucesso", "O email foi enviado", "success");
    } catch (err) {
      console.error(err);

      swal("Erro !", "Erro ao enviar email para aluno/parceiro", "error");
    }
  }, [aluno, emails, evento]);

  useEffect(() => {
    getEventos();
  }, []);

  useEffect(() => {
    getEmails();
  }, [evento]);

  useEffect(() => {
    const { id_evento } = router.query;

    const newEvento = Number(id_evento);

    setEvento(newEvento);
  }, [router]);

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Title>Enviar Emails de Evento</Title>

          <StyledForm>
            <Form.Field>
              <InscritosEventosSelector
                handleChange={(value) => handleDropdownChange(value, setAluno)}
              />
            </Form.Field>

            <Form.Field>
              <Label>Evento</Label>
              <StyledDropdown
                fluid
                selection
                options={eventosOptions}
                onChange={(e, { value }) =>
                  handleDropdownChange(value, setEvento)
                }
                value={evento}
              />
            </Form.Field>

            <Form.Field>
              <Label>Emails</Label>

              <StyledDropdown
                fluid
                selection
                multiple
                options={emailsOptions}
                onChange={(e, { value }) =>
                  handleDropdownChange(value, setEmails)
                }
                value={emails}
              />
            </Form.Field>
          </StyledForm>

          <ButtonGroup>
            <StyledButton color="green" onClick={handleSend}>
              Enviar
            </StyledButton>
          </ButtonGroup>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(EnviarEmailsInscricoesEventos);
